<template>
  <div>
    <div
      :class="{ 
      showCanvas: Object.keys(state.ERRORS).length === 0,
      hideCanvas: Object.keys(state.ERRORS).length !== 0
    }"
    >
      <canvas @click="click" id="AmortizationCanvas"></canvas>
    </div>
  </div>
</template>
<script>
import Chart from "chart.js";
import Moment from "moment";
import { mapState, mapMutations, mapGetters } from "vuex";

import { STATE, MUTATIONS, GETTERS } from "../storeConstants";
import { currency } from "../util/format";
import AmortizationChartData from "./chartData/AmortizationChartData";
import {
  paidPrincipleByPaymentNumber,
  totalInterestAfterNumPayments,
  principleByPaymentNumber
} from "../util/formula";

const { CHANGE } = MUTATIONS;
const {
  FORMATED_PAYMENT,
  PAYMENT,
  MODIFIED_TERM,
  INTERVAL_LENGTH_MONTHS
} = GETTERS;
const { MODIFY_TERM, TERM, INTEREST_RATE, PRINCIPLE, DOWNPAYMENT } = STATE;

export default {
  mounted() {
    this.$nextTick(() => {
      this.updatePointRadius(0);
    });
  },

  computed: {
    ...mapState({
      state: state => state.base
    }),
    display() {
      return this.state.CURRENT_DISPLAY;
    },
    ...mapGetters([
      FORMATED_PAYMENT,
      PAYMENT,
      MODIFIED_TERM,
      INTERVAL_LENGTH_MONTHS
    ]),
    chartData() {
      return AmortizationChartData({
        ...this.state,
        PAYMENT: this.PAYMENT,
        MODIFIED_TERM: this.MODIFIED_TERM,
        CHANGE: this.CHANGE
      });
    },
    hasShadowRoot() {
      return !!document.getElementsByTagName("mortgage-calculator").length;
    },
    ctx() {
      return this.hasShadowRoot
        ? document
            .getElementsByTagName("mortgage-calculator")[0]
            .shadowRoot.getElementById("AmortizationCanvas")
        : document.getElementById("AmortizationCanvas");
    },
    canvasRect() {
      return this.ctx.getBoundingClientRect(); //get the DOMrect obj of the canvas
    }
  },
  watch: {
    chartData: function() {
      this.chart();
    },
    MODIFIED_TERM() {
      this.chart();
    },
    display() {
      this.chart();
    }
  },
  data: function() {
    return {
      canvasInternalMarginLeft: 42,
      canvasInternalMarginRight: 3
    };
  },

  methods: {
    ...mapMutations([CHANGE]),
    updateClickIndex(clickPosition) {
      const clickIndex = Math.ceil(
        (clickPosition * this.MODIFIED_TERM) / this.state.INTERVAL
      );
      this.CHANGE({ target: "CHART_CLICK_INDEX", value: clickIndex });
    },

    clickSnapPosition: function() {
      if (this.state.CHART_CLICK_INDEX <= 0) return 0;
      if (
        this.state.CHART_CLICK_INDEX * this.state.INTERVAL >
        this.MODIFIED_TERM - 1
      )
        return (this.state.CHART_CLICK_INDEX - 1) * this.state.INTERVAL;

      return this.state.CHART_CLICK_INDEX * this.state.INTERVAL;
    },

    updatePointRadius(clickPosition) {
      let newPOINT_RADIUS = new Array(
        Math.floor(this.INTERVAL_LENGTH_MONTHS + 1)
      ).fill(0);
      newPOINT_RADIUS[this.state.CHART_CLICK_INDEX] = 5;
      this.CHANGE({
        target: "POINT_RADIUS",
        value: [...newPOINT_RADIUS]
      });
      this.CHANGE({
        target: "CHART_SELECTOR_SNAP_X",
        value: this.clickSnapPosition() //-1 to sync with PAYMENT_DATA which is an array
      });
      this.CHANGE({
        target: "CHART_SELECTOR_PERCENTAGE_X",
        value: clickPosition
      });
    },
    currency: currency,
    chart() {
      const chart = new Chart(this.ctx, this.chartData);
    },
    click(e) {
      if (Object.keys(this.state.ERRORS).length === 0) {
        //only allow a click if the chart is in a valid state
        const chartX =
          e.clientX - this.canvasRect.left - this.canvasInternalMarginLeft; //position of the click - the left position of the canvas
        const clickPosition =
          chartX /
          (this.canvasRect.width -
            this.canvasInternalMarginLeft -
            this.canvasInternalMarginRight); //percentage ascorss the canvas that the click took place
        this.updateClickIndex(clickPosition);
        this.updatePointRadius(clickPosition);
      }
    }
  }
};
</script>

<style scoped lang="scss">
#AmortizationCanvas {
  width: 100% !important;
  height: 100% !important;

  min-width: 328px !important;
  min-height: 328px !important;
}
.showCanvas {
  background-color: transparent;
  width: 100% !important;
  height: 100% !important;
}
.hideCanvas {
  background-color: #e1e1e1;
}
.amortization-graph {
  height: 100%;
  max-height: 516px;
  position: relative;
  > * {
    margin: auto;
    left: -2px;
    position: relative;
  }
}
.dateline {
  width: 2px;
  height: 100%;
  background-color: #e1e1e1;
  position: absolute;
}
.pointer {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: purple;
  position: absolute;
  left: 100;
  top: 100;
}
</style>